import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasAccess } from '../lib/rbacMatrix';

/**
 * Wraps a route element with role-based access control.
 *
 *   <ProtectedModuleRoute user={user} allowedRoles={RBAC.NON_GUEST}>
 *     <MyComponent />
 *   </ProtectedModuleRoute>
 *
 * - If user is not logged in → redirect to /login
 * - If user is logged in but role is not in allowedRoles → redirect to /dashboard
 *   (the dashboard itself is open to every authenticated user, so this is a
 *   safe "you don't have permission" landing page)
 */
const ProtectedModuleRoute = ({ user, allowedRoles, redirectTo, children }) => {
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (!hasAccess(user, allowedRoles)) {
    return <Navigate to={redirectTo || '/dashboard'} replace />;
  }
  return children;
};

export default ProtectedModuleRoute;
